import React from 'react';
type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
};
export const Modal = ({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) => {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-97">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-auto" data-id="element-98">
        <div className="flex justify-between items-center p-6 border-b" data-id="element-99">
          <h3 className="text-xl font-bold" data-id="element-100">{title}</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-id="element-101">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-102">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-103" />
            </svg>
          </button>
        </div>
        <div className="p-6" data-id="element-104">{children}</div>
        <div className="p-6 border-t flex justify-end" data-id="element-105">
          <button onClick={onClose} className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded" data-id="element-106">
            Close
          </button>
        </div>
      </div>
    </div>;
};